import type { JSX } from 'react';

interface LogoProps {
  size?: number;
  className?: string;
  title?: string;
}

export function BitzBuggyLogo({
  size = 48,
  className,
  title = 'BitzBuggy',
}: LogoProps): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      className={className}
      role="img"
      aria-label={title}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      <defs>
        <linearGradient id="bb-bg" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#1a2540" />
          <stop offset="100%" stopColor="#0b0d12" />
        </linearGradient>
        <linearGradient id="bb-spark" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#7dd3ff" />
          <stop offset="100%" stopColor="#3aa8ff" />
        </linearGradient>
      </defs>
      <rect x="5" y="5" width="90" height="90" rx="18" fill="url(#bb-bg)" />
      <path
        d="M52 18 L30 56 L48 56 L42 82 L74 40 L54 40 Z"
        fill="url(#bb-spark)"
        stroke="#cfe9ff"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <circle cx="50" cy="50" r="34" fill="none" stroke="#3aa8ff" strokeWidth="1" opacity="0.35" />
    </svg>
  );
}
